import { render, staticRenderFns } from "./DataCenter.vue?vue&type=template&id=07fa3f4a&scoped=true"
import script from "./DataCenter.vue?vue&type=script&lang=js"
export * from "./DataCenter.vue?vue&type=script&lang=js"
import style0 from "./DataCenter.vue?vue&type=style&index=0&id=07fa3f4a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fa3f4a",
  null
  
)

export default component.exports